import { connect } from 'react-redux'

import SwitchProTrackBlock from './SwitchProTrackBlock.jsx'
import WhyYouChangeProTrack from 'app/domains/common/WhyYouChangeProTrack'
import { modal } from 'store/entities/modal/actions'

const mapDispatchToProps = {
  handleOnClick: () => modal.show(WhyYouChangeProTrack),
}

export default connect(null, mapDispatchToProps)(SwitchProTrackBlock)
